import user from '@/data/user'
import { RouteLocationRaw } from 'vue-router'
import router from '../router'
import depend from './depend'

export interface dependType {
  load: 'un' | 'ing' | 'end'
  loadMain: () => Promise<unknown>
  loadExtra: () => Promise<unknown>
  loadData: () => Promise<unknown>
  reset: () => void
}

export const loginPath = ['/login']
export const whitePath = ['/404'].concat(loginPath)
const body = document.body
// 从本地获取登录和token数据
user.changePage('index')

// 当不存在ticket时从缓存获取token信息，否则不获取，在路由守卫中会调用token登录逻辑
user.getDataByLocal()

const check = function(type: 'login' | 'depend') {
  if (type === 'login') {
    return user.$getStatus('load') === 'success'
  } else {
    return depend.load === 'end'
  }
}

router.beforeEach((to, from, next) => {
  const finalNext = (location?: RouteLocationRaw) => {
    body.style.backgroundColor = '#FBFBFB'
    if (location) {
      next(location)
    } else {
      next()
    }
  }
  if (check('login')) {
    // 已登录: 登陆页面跳转首页，否则判断依赖
    if (loginPath.indexOf(to.path) !== -1) {
      finalNext({ path: '/' })
    } else if (!check('depend')) {
      depend.loadData().then(() => {
        const redirect = decodeURIComponent(from.query.redirect as string || to.path)
        if (to.path === redirect) {
          // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          finalNext({ ...to, replace: true })
        } else {
          // 跳转到目的路由
          finalNext()
        }
      }).catch(() => {
        finalNext({ path: loginPath[0], query: { redirect: to.fullPath } })
      })
    } else {
      finalNext()
    }
  } else {
    // 未登录跳转登录或者直接进入白名单
    if (whitePath.indexOf(to.path) !== -1) {
      finalNext()
    } else {
      finalNext({ path: loginPath[0], query: { redirect: to.fullPath } })
    }
  }
})
